import QualificationsModule from './containers/qualificationsModule'

export {default as QualificationsModuleLayout} from './components/qualificationsModuleLayout'

export default QualificationsModule
